var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.as,{tag:"component",staticClass:"w-menu-list"},[_vm._t("default",function(){return _vm._l((_vm.list),function(item){return _c(_setup.WMenuItem,{key:item.code,attrs:{"label":item.text,"selected":_vm.selectedItem?.code === item.code},on:{"click":function($event){return _setup.onClick(item)}}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }